import MouseTracker from'../../../fc-core/src/mouse-tracker';import{componentFactory}from'../../../fc-core/src/lib';export default function(a){let b;a.config.enablemousetracking?(componentFactory(a,MouseTracker,'mouseTracker'),b=a.getChildren('mouseTracker')[0],!a.config.mouseTrackerEventAdded&&(b.addEvents(),a.config.mouseTrackerEventAdded=!0)):(b=a.getChildren('mouseTracker')&&a.getChildren('mouseTracker')[0],b&&b._removeListners(),a.config.mouseTrackerEventAdded=!1)}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-charts/src/factories/mouse-tracker.js
// module id = null
// module chunks = 